import {Component, Input, OnInit} from '@angular/core';
import {News} from '../../models/models';
import {Translation} from '../../models/translation';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'app-news-element',
  templateUrl: './news-element.component.html',
  styleUrls: ['./news-element.component.css']
})
export class NewsElementComponent implements OnInit {
  @Input() news: News;
  constructor(private sanitizer: DomSanitizer) { }

  public translation: Translation;
  public safeHtml: any;

  ngOnInit() {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.news.Content);
    this.translation = JSON.parse(localStorage.getItem('Translation'));
  }
}
